import { createQueryKeys } from '@lukemorales/query-key-factory';
import { deviceApis } from '../../apis/device/apis';
import type { IGetDispatchByMacParams, IGetDispatchHistoryParams } from '../../apis/device/shipment/types';
import type { IDispatch } from '../../../components/units/Management/Dispatch/List/types';

export const shipmentQueries = createQueryKeys('shipment', {
  history: (params: IGetDispatchHistoryParams) => ({
    queryKey: [params.page, params.size, params.mac],
    queryFn: async (): Promise<{ data: IDispatch[]; totalCount: number }> => {
      const response = await deviceApis.shipment.getDispatchHistory(params);
      return response.data;
    },
  }),
  byMac: (params: IGetDispatchByMacParams) => ({
    queryKey: [params.mac],
    queryFn: async (): Promise<{ data: IDispatch[] }> => {
      const response = await deviceApis.shipment.getDispatchByMac(params);
      return response.data;
    },
  }),
});
